class UgcCarousel extends HTMLElement {
    constructor() {
        super();
        this.splideInitialized = false;
    }
    connectedCallback() {
        // Initialize when element is connected to DOM
        // This works for both initial load and theme editor refreshes
        if (this.splideInitialized) {
            return;
        }
        this.splideElement = this.querySelector(".splide");
        if (!this.splideElement) {
            return;
        }
        this.splideId = this.splideElement.getAttribute("id");
        
        // Wait for Splide library to be available
        const initWhenReady = () => {
            if (window.Splide) {
                this.initSplide();
            } else {
                // Retry after a short delay if Splide isn't loaded yet
                setTimeout(initWhenReady, 50);
            }
        };
        
        // Check if DOM is already loaded or wait for it
        if (document.readyState === 'loading') {
            document.addEventListener("DOMContentLoaded", () => {
                initWhenReady();
            });
        } else {
            // DOM is already loaded, initialize when Splide is ready
            initWhenReady();
        }
    }
    disconnectedCallback() {
        // Clean up when element is removed from DOM
        if (this.splide && this.splideInitialized) {
            this.splide.destroy();
            this.splide = null;
            this.splideInitialized = false;
        }
    }
    initSplide() {
        if (this.splideInitialized) {
            return;
        }
        
        // Get arrow settings from data attributes
        const arrowsMobile = this.splideElement?.getAttribute("data-arrows-mobile") === "true";
        const arrowsDesktop = this.splideElement?.getAttribute("data-arrows-desktop") === "true";
        
        // Get trimSpace setting from data attribute
        const trimSpace = this.splideElement?.getAttribute("data-trim-space") === "true";
        
        // Determine initial arrows setting (default to desktop setting)
        // Splide will handle responsive visibility via breakpoints
        const arrowsEnabled = arrowsDesktop || arrowsMobile;
        
        this.splide = new window.Splide("#" + this.splideId, {
            perPage: 3,
            perMove: 1,
            updateOnMove: true,
            snap: true,
            drag: true,
            trimSpace: trimSpace,
            pagination: this.splideElement?.hasAttribute("data-pagination")
                ? this.splideElement?.getAttribute("data-pagination") == "false"
                    ? false
                    : true
                : false,
            arrows: arrowsEnabled,
            flickPower: 100,
            flickMaxPages: 1,
            focus: 0,
            gap: "calc(var(--padding-sections-desktop) / 2)",
            padding: {
                right: "var(--padding-sections-desktop)",
            },
            breakpoints: {
                750: {
                    perPage: 1,
                    arrows: arrowsMobile,
                    padding: {
                        left: "var(--padding-sections-desktop)",
                        right: "var(--padding-sections-desktop)",
                    },
                },
            },
        });
        this.splide.mount();
        this.splideInitialized = true;
        this.splide.on("move", (newIndex) => {
            this.onSlideMove(newIndex);
        });
        this.splide.on("click", (slide) => {
            this.splide.go(slide.index);
            const video = slide.slide.querySelector("video");
            if (video) {
                video.play();
            }
        });
        this.splide.on("active", (slide) => {
            const video = slide.slide.querySelector("video");
            if (video) {
                video.play();
            }
        });
        this.splide.on("inactive", (slide) => {
            const videos = slide.slide.querySelectorAll("video");
            if (videos.length) {
                videos.forEach((video) => {
                    video.pause();
                });
            }
        });
        //Behavior for videos
        const videos = this.querySelectorAll("video");
        videos.forEach((video) => {
            video.addEventListener("play", () => {
                //Check if the video is in the active slide
                const parent = video.closest(".splide__slide");
                if (!parent.classList.contains("is-active")) {
                    this.pauseAllVideos(video);
                }
                const index = parseFloat(parent.getAttribute("data-slide-index"));
                this.splide.go(index);
            });
        });
    }
    onSlideMove(newIndex) {
        const relatedContent = this.querySelectorAll(".js-slide-content");
        if (relatedContent.length) {
            relatedContent.forEach((content) => {
                if (parseFloat(content.getAttribute("data-slide-index")) !== newIndex) {
                    content.classList.add("hidden");
                } else {
                    content.classList.remove("hidden");
                }
            });
        }
    }
    pauseAllVideos(except) {
        // Pause all videos except the one passed as an argument
        const videos = this.querySelectorAll("video");
        if (videos.length) {
            videos.forEach((video) => {
                if (video !== except) {
                    video.pause();
                }
            });
        }
    }
}

if (!customElements.get("ugc-carousel")) {
    customElements.define("ugc-carousel", UgcCarousel);
}
